module.exports = __webpack_public_path__ + "static/media/OWL_Logos_Final-03.b85a396d.png";